export default __webpack_public_path__ + "static/media/balondeoro.0d6d30be.png";